module.exports = __webpack_public_path__ + "static/media/service-6.aab5efcb.svg";